import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// import Sidebar from '../../components/Sidebar';
import UserBasicInfo from './UserBasicInfo';
import AddressTable from './AddressTable';
import OrderHistory from './OrderHistory';
import PaymentModal from './PaymentModal';
import OrderItemsModal from './OrderItemsModal';

import { AppDispatch, RootState } from '../../state/store';
import { fetchUserProfileData } from '../../state/slices/userProfileSlice';
import { Order, items, PaymentDetails } from '../../interfaces/user';

import './ProfilePage.css';
import StatusMessage from '../../auth/StatusMessage';
import Loading from '../../components/Loading';
// import { User } from 'lucide-react';
import MainNavbar from '../../pages/MainNavbar';
import Breadcrumbs from '../../components/Breadcrumbs';
import { useAuth } from '../../context/AuthContext';

const UserProfilePage: React.FC = () => {
   const { currentUser } = useAuth();
  const dispatch = useDispatch<AppDispatch>();

  const {
    user,
    addresses,
    getOrders: orders,
    getTransactions,
    loading,
    error
  } = useSelector((state: RootState) => state.userProfile);

  const [showModal, setShowModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState<PaymentDetails | null>(null);
  const [showItemsModal, setShowItemsModal] = useState(false);
  const [selectedOrderItems, setSelectedOrderItems] = useState<items[] | null>(null);

  const [addressSearch, setAddressSearch] = useState('');
  const [orderSearch, setOrderSearch] = useState('');
  const [isSidebarOpen] = useState(false);
  const [isMobile] = useState(window.innerWidth <= 768);
   const [showSubnav, setShowSubnav] = useState(false);
  
      const userId = currentUser?.id || "";
      const isLoggedIn = !!currentUser;

  useEffect(() => {
    if (userId) dispatch(fetchUserProfileData(userId));
  }, [userId, dispatch]);

  const handlePaymentClick = (transactionId: string | null) => {
    if (!transactionId || !getTransactions) return;
    const payment = getTransactions.find(t => t.id === transactionId);
    if (payment) {
      setSelectedPayment(payment);
      setShowModal(true);
    }
  };

  const handleItemsClick = (order: Order) => {
    setSelectedOrderItems(order.items || []);
    setShowItemsModal(true);
  };

 if (loading) return <Loading />;
if (error) return <StatusMessage type="error" message={`Error: ${error}`} />;
if (!user) return <StatusMessage type="notfound" />;

  return (
    <>
     <MainNavbar
                searchQuery=""
                setSearchQuery={() => { }}
                isLoggedIn={isLoggedIn}
                showSubnav={showSubnav}
                setShowSubnav={setShowSubnav}
                userId={userId}
                disableSearch={true} // Disable search in cart page
            />
            <Breadcrumbs />
  
            <div className="profile-container">
            <div className={`profile-content ${isSidebarOpen && !isMobile ? '' : 'collapsed'}`}>
                <div className="info-address-container">
                <div className="info-card">
                <UserBasicInfo user={user} />
                </div>
                <div className="address-card profile-section">
                <h3>Saved Addresses</h3>
                <AddressTable
                    addresses={addresses || []}
                    search={addressSearch}
                    onSearchChange={setAddressSearch}
                    loading={loading}
                />
                </div>
            </div>


                <section className="profile-section">
                <h3>Order History</h3>
                <OrderHistory
                    orders={orders || []}
                    search={orderSearch}
                    onSearchChange={setOrderSearch}
                    onPaymentClick={handlePaymentClick}
                    onItemsClick={handleItemsClick}
                />
                </section>

                {showModal && selectedPayment && (
                <PaymentModal data={selectedPayment} onClose={() => setShowModal(false)} />
                )}
                {showItemsModal && selectedOrderItems && (
                <OrderItemsModal
                    items={selectedOrderItems}
                    products={[]}
                    onClose={() => setShowItemsModal(false)}
                />
                )}
            </div>
            </div>
      </>
  );
};

export default UserProfilePage;
